// HomePage.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/HomePage.scss';
import Header from '../common/Header';
import ContactsSection from './ContactsSection';
import Footer from '../common/Footer';
import { Helmet } from 'react-helmet-async';

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVh();
    window.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);


  const handleMenuRedirect = () => {
    navigate('/menu');
  };

  return (
    <div>
      <Helmet>
        <title>CosyHole</title>
        <meta name="description" content="Pizzeria Birreria CosyHole - Scopri il nostro menù ricco di pizze deliziose e birre artigianali. Vieni a gustare i sapori autentici preparati con ingredienti freschi e di alta qualità." />
      </Helmet>
      <Header>
        <div className='header-child'>
          <h2 data-aos="fade-right">Benvenuto da</h2>
          <h1 data-aos="fade-right">CosyHole</h1>
          <p data-aos="fade-up">Scopri il nostro menù</p>
          <button data-aos="fade-up" className="menu-button" onClick={handleMenuRedirect}>
            Menù
          </button>
        </div>
      </Header>
      <div key="home-container" data-aos="fade-up" className="home-container">
        <div className="pub-hours">
          <h2 data-aos="fade-right">I nostri orari</h2>
          <ul data-aos="fade-up">
            <li data-aos="fade-up">
              <span className="day">Lunedì:</span>
              <span className="closed">Chiuso</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Martedì:</span>
              <span className="hours">18:00 - 00:00</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Mercoledì:</span>
              <span className="hours">18:00 - 00:00</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Giovedì:</span>
              <span className="hours">18:00 - 00:00</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Venerdì:</span>
              <span className="hours">18:00 - 01:00</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Sabato:</span>
              <span className="hours">18:00 - 01:00</span>
            </li>
            <li data-aos="fade-up">
              <span className="day">Domenica:</span>
              <span className="hours">18:00 - 00:00</span>
            </li>
          </ul>
        </div>
        <ContactsSection />
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;
